'use client';

import { Disclosure, Transition } from '@headlessui/react';
import Typography from '@ui/Typography';
import Chip from '@ui/Chip';
import React from 'react';
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md';

function VolunteerSkills(props) {
  const { skills } = props;
  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full gap-3">
            <Typography variant="body1" color="textSecondary">
              Skills Needed
            </Typography>
            <MdOutlineKeyboardArrowDown
              className={`${
                open ? 'rotate-180 transform' : ''
              } h-5 w-5 text-text-secondary`}
            />
          </Disclosure.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0">
            <Disclosure.Panel className="flex flex-wrap items-center gap-2">
              {skills.map((skill) => (
                <Chip key={skill.id} color="secondary" text="small">
                  {skill.skill_title}
                </Chip>
              ))}
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}

export default VolunteerSkills;
